import React from 'react';
import DateRangePicker from './DateRangePicker';
import RecaptchaInput from './RecaptchaInput';
import TextInput from './TextInput';
import TextArea from './TextArea';
import NumberInput from './NumberInput';
import Select from './Select';
import Checkbox from './Checkbox';
import DatePicker from './DatePicker';
import TimeInput from './TimeInput';
import PasswordInput from './PasswordInput';
import InlineForm from './InlineForm';
import EmailInput from './EmailInput';
import FieldWrapper from './FieldWrapper';
import JSONInput from './JSONInput';
import TranslationsInput from './TranslationsInput';
import CoordinatesInput from './CoordinatesInput';
import FileInput from './FileInput/FileInput';
import RichTextEditorInput
    from './RichTextEditor/RichTextEditor';

export {
    TextInput, TextArea, NumberInput, Select, Checkbox, DatePicker, TimeInput, InlineForm, RecaptchaInput, FieldWrapper,
};

export const GROMMET_UI_DEFAULT_FIELDS = {
    text: TextInput,
    text_area: TextArea,
    number: NumberInput,
    password: PasswordInput,
    choice: Select,
    boolean: Checkbox,
    date: DatePicker,
    datetime: DatePicker,
    time: TimeInput,
    subform: InlineForm,
    datetime_range: DatePicker,
    email: EmailInput,
    recaptcha: RecaptchaInput,
    json: JSONInput,
    translations: TranslationsInput,
    geometry: CoordinatesInput,
    file: FileInput,
    rte: RichTextEditorInput,
    date_range: DateRangePicker,
};

export const GROMMET_UI_FALLBACK_FIELD_TYPE = 'text';
